import { type JSX, useEffect } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { AnimateHeightChange } from '@/shared/components/AnimateHeightChange';
import { DisableSSR } from '@/shared/components/DisableSSR';
import { BraggingCard } from '@/shared/components/swap-flow/BraggingCard/BraggingCard';
import { RouteList } from '@/shared/components/swap-flow/RouteList/RouteList';
import useScreenSize from '@/shared/hooks/useScreenSize';
import useSettingsStore from '@/shared/hooks/useSettingsStore';
import useSwapRequestStore, { selectShowRouteList } from '@/shared/hooks/useSwapRequestStore';
import { defaultAnimationProps } from '@/shared/utils/consts';
import SwapCard from '../components/SwapPage/SwapCard/SwapCard';

export default function Index(): JSX.Element {
  const { isMobile } = useScreenSize();
  const showRouteList = useSwapRequestStore(selectShowRouteList);
  const setIsOnChainSwap = useSettingsStore((state) => state.setIsOnChainSwap);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
      setIsOnChainSwap(false); // avoid collision on localhost with lp app
    }
  }, []);

  return (
    <DisableSSR>
      <AnimateHeightChange>
        {isMobile ? (
          <div className="flex flex-col space-y-6 md:hidden" key="mobile">
            <SwapCard />
            <AnimatePresence mode="wait">
              {showRouteList && (
                <motion.div key="route-list" {...defaultAnimationProps}>
                  <RouteList />
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ) : (
          <div className="hidden justify-center space-x-6 md:flex" key="desktop">
            <SwapCard />
            <AnimatePresence mode="wait">
              {showRouteList ? (
                <motion.div key="route-list" {...defaultAnimationProps}>
                  <RouteList />
                </motion.div>
              ) : (
                <motion.div key="bragging-card" {...defaultAnimationProps}>
                  <BraggingCard />
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        )}
      </AnimateHeightChange>
    </DisableSSR>
  );
}
